export default () => {
    const ricettariMenu = document.querySelectorAll('.js-ricettariMenu');
    
    if(ricettariMenu){
      ricettariMenu.forEach(el => {
        if(document.body.classList.contains('logged-in')){
          el.href ='https://cdn.jumpgroup.it/sites/puroebio/uploads/2024/ricettario_puroebio_2024.zip'; //jumpcpmm-sites-purobio-2023
        }
      });
    }

}